import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Image, Message, Toast, Header } from 'react-frontier';
import { Asset, UserAsset, SetLoading, AssetType } from '../SiteClasses';
import moment from 'moment';
import API from '../API';
import { Link } from 'react-router-dom';
import { bindClick } from '../SiteUtil';

interface AssetViewModalProps{
	open: boolean;
	onClose: () => void;
	asset: Asset | UserAsset;
	delete?: boolean;
	onDeleted?: (asset_id: number) => void;
}

var AssetViewModal = (props: AssetViewModalProps)=>{
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [deleteAsset, setDeleteAsset] = useState<boolean>(false);
	var isDelete = props.delete || deleteAsset;

	useEffect(()=>{
		setDeleteAsset(false);
	}, [props.open]);

	var sendDelete = (setLoading: SetLoading)=>{
		setLoading(true);

		API.deleteAsset(props.asset.asset_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Archivo eliminado!');
			props.onDeleted?.(props.asset.asset_id);
			props.onClose();
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado eliminando el archivo (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};
	
	return !isDelete ? (
		<Modal className='basic asset-view' open={props.open} onClose={props.onClose}>
			{!!(props.asset && props.open) && (
				<Modal.Content>
					{props.asset.type_id === AssetType.VIDEO ? (
						<video controls style={{ maxWidth: '100%', maxHeight: '70vh' }} src={props.asset.download_url} />
					) : (
						<Image src={props.asset.url} style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />
					)}
					{props.asset.type_id===AssetType.PDF && (
						<Button className='pdf-view' text='Ver PDF' color='black' iconName='external-link' as={Link} to={props.asset.download_url} target='_blank' />
					)}
					<div className="buttons">
						<Button text='Eliminar archivo' basic color='red' onClick={bindClick(setDeleteAsset, true)} />
					</div>
				</Modal.Content>
			)}
		</Modal>
	) : (
		<Modal open={props.open} onClose={props.onClose} size='tiny'>
			<Modal.Header>¿Eliminar archivo?</Modal.Header>
			{!!props.asset && (
				<Modal.Content>
					<Header text={'Eliminar archivo'} subtext='Esta acción no se puede deshacer' style={{ marginBottom: 20 }} />
					<Table fitted details striped className='first last'
						style={{ marginTop: 15 }}
						data={[
							['ID', props.asset.asset_id],
							['Nombre', props.asset.asset_name],
							...('user_asset_type_name' in props.asset && props.asset.user_asset_type_name 
								? [['Tipo', props.asset.user_asset_type_name]] 
								: []
							),
							['Creación', moment.unix(props.asset.date_created).format('DD/MM/YY HH:mm')],
							['Creador', props.asset.user_creator_name?.toUpperCase() || 'N/A'],
							['Descripción', props.asset.description || 'Sin descripción'],
						]}
					/>
					<Message type="error" list={modalPrompts} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={props.onClose} />
				<Button text='Eliminar' color='red' onClick={sendDelete} />
			</Modal.Actions>
		</Modal>
	);
};

export default AssetViewModal;
